import React from 'react'
import styled from 'styled-components'


const Link = ({ children, link }) => {
  return <Wrap href={link}>{children}</Wrap>
}

export default Link

const Wrap = styled.a`
  text-decoration: none;
`
